export interface Ticket {
  id: string;
  key: string; // Ticket key like "PROJ-1"
  summary: string; // Ticket title/summary
  description: string; // Full ticket description
  status: TicketStatus; // Current status
  priority: TicketPriority; // Priority level
  type: TicketType; // Ticket type
  url?: string; // URL (optional, can be auto-generated or empty)
  lastSyncedAt: Date; // Last sync time (will use current time for manual updates)
  projectId: string; // Associated project ID
  created?: Date; // Creation timestamp (optional, for new tickets)
}

export enum TicketStatus {
  TO_DO = 'To Do',
  IN_PROGRESS = 'In Progress',
  DONE = 'Done',
  CLOSED = 'Closed',
  RESOLVED = 'Resolved',
}

export enum TicketPriority {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  CRITICAL = 'Critical',
}

export enum TicketType {
  TASK = 'Task',
  BUG = 'Bug',
  STORY = 'Story',
  EPIC = 'Epic',
  SUBTASK = 'Subtask',
}
